import { StyledInputBox } from "./styled";
import { StyledFormError } from "../../styles/ErrorMessage";

const InputBox = ({label, name, placeholder, register, type, errors, value})=>{

    return (
        <StyledInputBox>
            <label htmlFor={name}>{label}</label>
            <input {...register} id={name} type={type} placeholder={placeholder} className={errors && "invalidInput"} value={value}/>
            {errors && <StyledFormError>{errors.message}</StyledFormError>}
        </StyledInputBox>

    )
    

}

export default InputBox